module.exports = __webpack_public_path__ + "img/9788934940258.acc59082.jpg";